
import objectPath from 'object-path'

const mutations = {
  updateFormState(state, payload) {
    state.formState = {
      ...state.formState,
      ...payload
    }
  },
  setField(state, { target, value }) {
    objectPath.set(state, target, value)
  },
}

export default mutations